import { createSlice } from "@reduxjs/toolkit";
import {API} from "aws-amplify";
import {dispatch} from "../index";

const apiName = process.env.REACT_APP_ENDPOINT_NAME;
const path_get_auth_plan = process.env.REACT_APP_AUTH_GET_PLAN;
const path_post_create_user = process.env.REACT_APP_AUTH_POST_CREATE_USER;
const initialState = {
    auth_error: null,
    username: '',
    accessToken: '',
    jwtToken: '',
    user_attributes: {},
    loggedIn: true,
    planName: null,
    success_message: ''
}

// ==============================================|| SLICE - Auth User ||=============================================

const authuser = createSlice({
    name: "authuser",
    initialState: initialState,
    reducers: {
        hasError(state, action) {
            state.auth_error = action.payload.response;
        },
        handlerSetAuthUser(state ,action) {
            state.username = action.payload.username;
        },
        handlerSetLogIn(state, action){
            state.loggedIn = action.payload.loggedIn;
        },
        handlerSetTokens(state, action) {
            state.accessToken = action.payload.accessToken;
            state.jwtToken = action.payload.jwtToken;
        },
        handleSetUserAttributes(state, action) {
            state.user_attributes = action.payload.user_attributes;
        },
        handlerResetAuthError(state, action){
            console.log(action);
          state.auth_error = action.payload.auth_error;
          return state;
        },
        getAuthPlanSuccess(state, action){
            state.planName = action.payload.planName;
        },
        postCreateUserSuccess(state, action){
            state.planName = action.payload.planName;
            state.success_message = action.payload.success_message;
        }
    }
})

export default authuser.reducer;

export function getAuthPlan(user_email){
    return async() => {
        console.log(user_email);
    var myInit = {};
    myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        "user_email": user_email
      }
    }
    API.get(apiName, path_get_auth_plan, myInit)
        .then(response => {
            dispatch(authuser.actions.getAuthPlanSuccess(response.data))
        }).catch(error => {
            dispatch(authuser.actions.hasError(error))
    })
  };
}

export function postCreateUser(xero_tenant, subscription_id){
    return async() => {
    var myInit = {};
    myInit = {
      headers: {},
      body: {
        xero_tenant, subscription_id
      }
    }
    API.post(apiName, path_post_create_user, myInit)
        .then(response => {
            dispatch(authuser.actions.postCreateUserSuccess(response.data))
        }).catch(error => {
            dispatch(authuser.actions.hasError(error))
    })
  };
}



export const {handlerSetAuthUser, handlerResetAuthError, handlerSetTokens, handleSetUserAttributes, handlerSetLogIn} = authuser.actions;